import { getBootstrapData } from "@ui/bootstrap-data/bootstrap-data-store";
import { Track } from "@app/web-player/tracks/track";
import { MediaItem } from "@common/player/media-item";
import { PlayerState } from "@common/player/state/player-state";
import { apiClient } from "@common/http/query-client";
import { guessPlayerProvider } from "@common/player/utils/guess-player-provider";

export function playerAd(state: () => PlayerState) {
  const permissions =
    getBootstrapData().user?.permissions ??
    getBootstrapData().guest_role?.permissions;
  const hideAudioAds = permissions?.some(
    (permission) => permission.name === "ads.hide.audio",
  );
  if (hideAudioAds) {
    const noop = () => {};
    return {
      startTimer: noop,
      stopTimer: noop,
      resetTimer: noop,
      getAd: () => undefined,
      resetAd: noop,
      isWaiting: () => false,
    };
  }

  let adZone: number =
    getBootstrapData().user?.ads?.audio?.zone ??
    getBootstrapData().settings.ads?.audio?.zone ??
    47;
  let exclued: Array<number> = [];
  let playtime: number = 0;
  let playTimeRef: number =
    getBootstrapData().settings.ads?.audio?.playTimeRef ?? 7;
  let interval: any;
  let interval_timer: number = 100;
  let adRemote: MediaItem;
  let waitingAd: boolean = false;

  playTimeRef *= 1000 * 60;

  const startTimer = () => {
    clearInterval(interval);

    if (!waitingAd) {
      // console.log('AD::startTimer()');
      interval = setInterval(() => {
        playtime += interval_timer;
        // console.log(playtime, playTimeRef, playtime >= playTimeRef, !waitingAd);
        if (playtime >= playTimeRef && !waitingAd) {
          clearInterval(interval);
          getAdRemote(exclued);
        }
      }, interval_timer);
    }
  };

  const stopTimer = () => {
    // console.log('AD::stopTimer()');
    clearInterval(interval);
  };

  const resetTimer = () => {
    // console.log('AD::resetTimer()');
    playtime = 0;
  };

  const getAdRemote = async (exclued: Array<number>) => {
    // console.log('AD::getAdRemote()');
    try {
      const response = await apiClient.get(
        `https://kads.corsica/ad?zone=${adZone}&type=json&format=audio&exclude=${exclued.join(",")}`,
      );
      const adData = response.data;

      // Ajouter l'ID de l'annonce à `exclued` pour éviter de la rejouer
      if (adData && adData.id) exclued.push(adData.id);

      // Sauvegarde de la pub en attendant de la lire
      if (adData) setAdRemote(adData);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données d'annonce:",
        error,
      );
    }
  };

  const setAdRemote = (adData: {
    success: boolean;
    id: number;
    source: string;
    track: {
      image: string;
      link: string;
      name: string;
      publisher: string;
    };
  }) => {
    // console.log('AD::setAdRemote()');
    adRemote = {
      id: adData.id,
      src: adData.source,
      poster: adData.track.image,
      isAd: true,
      provider: guessPlayerProvider(adData.source, "audio"),
      meta: {
        id: adData.id,
        name: adData.track.name,
        link: adData.track.link,
        ad_link: adData.track.link,
        type: null,
        number: 1,
        duration: null,
        youtube_id: null,
        spotify_popularity: null,
        owner_id: 1,
        src: adData.source,
        encoded: null,
        plays: null,
        created_at: "2024-10-06T16:59:16.000000Z",
        image: adData.track.image,
        model_type: "track",
        artists: [
          {
            id: 0,
            name: adData.track.publisher,
            image_small: null,
            model_type: "artist",
          },
        ],
        album: {
          id: 0,
          name: adData.track.name,
          image: adData.track.image,
          model_type: "album",
        },
      },
      groupId: "ad.*",
    };
    waitingAd = true;
  };

  const getAd = () => {
    // console.log('AD::getAd()');
    return waitingAd ? adRemote : undefined;
  };

  const resetAd = () => {
    // console.log('AD::resetAd()');
    waitingAd = false;
  };

  const isWaiting = () => {
    // console.log('AD::isWaiting()', waitingAd);
    return waitingAd;
  };

  return {
    startTimer,
    stopTimer,
    resetTimer,
    getAd,
    resetAd,
    isWaiting,
  };
}
